module.exports = __webpack_public_path__ + "img/微信图片_20251027135746_1192_62.8b0a67c4.jpg";